import { attributes, define, Events, refTo, type } from '@type-r/models';
import { Linked, useIO, useModel } from '@type-r/react';
import { FormSelect, PopupIODialog, Option, FormInput } from 'lqx-react';
import * as React from 'react';
import { CompanyModel, globalStore, RelationshipModel } from 'api';
import { getFacilities, Payment, processPayment } from 'src/app/pages/inmatch/api';
import { UnresolvedPayment } from '../../api/unresolvedPayment';
import { PaymentDetails } from '../../bank-transactions/unresolved/details';
import { Loading } from 'lqx-react/src';
import { makeStyles } from '@material-ui/core';

@define 
class State extends attributes({
    facilityId : Number,
    startDate : type(Date).value(undefined),
    endDate : type(Date).value(undefined),
}){
}

export const ReprocessPaymentDialog = ({ $isOpen, payment} : {
    $isOpen : Linked<boolean>,
    payment : Payment,
}) => {
    const state = useModel(State);

    const [facilities, setFacilities] =  React.useState([]);

    const isReady = useIO( async ()=> {
        const result = await getFacilities(payment.id);
        setFacilities(result.sort((a, b) => a.facilityName.localeCompare(b.facilityName)));
    }, [payment.id])
    
    const classes = useStyles();
    
    return (
        <PopupIODialog
            classes={classes}
            $isOpen={ $isOpen }
            title="Reprocess Payment"
            actionLabel="Confirm"
            maxWidth="lg"
            success='The Payment is being Reprocessed'
            disabled={false}
            doIO={ async () => {
                await processPayment(Number(payment.id), state.facilityId, state.startDate, state.endDate);
            }}
            onSuccess={
                () => Events.trigger( "selectedPayment:refresh" )
            }
        >
            {isReady ? 
            <>
                <FormSelect label="Facility" $value={state.$.facilityId}>
                    {facilities && facilities.map(facility => {
                        return (
                            <Option key={facility.facilityId} value={facility.facilityId}>{facility.facilityName}</Option>
                        );
                    })}
                </FormSelect>
                <FormInput label="Start Date" date $value={state.$.startDate} maxDate={state.endDate}/>
                <FormInput label="End Date" date $value={state.$.endDate} minDate={state.startDate}/>
            <p>This will reprocess the payment in the background - This may take a while to complete.</p></> : <Loading/> }
        </PopupIODialog> )
}

const useStyles = makeStyles({
    paper : {
        position: 'relative',
        overflow: 'visible',
    },
});